import styled, { css } from 'styled-components';

/**
 * The app's buttons. `primary` is the one main thing to do next; everything else is the quieter default.
 */
type ButtonProps = {
  $primary?: boolean;
  $danger?: boolean;
  $block?: boolean;
};

export const Button = styled.button<ButtonProps>`
  border: 0;
  border-radius: 10px;
  padding: 10px 16px;
  min-height: 42px;
  font-weight: 600;
  background: rgba(255, 255, 255, .1);
  color: var(--ink);
  cursor: pointer;

  ${props => props.$primary && css`
    background: var(--accent);
    color: var(--accent-ink);
    font-weight: 700;
  `}

  ${props => props.$danger && css`
    background: rgba(227, 64, 47, .18);
    color: #ff8c80;
  `}

  ${props => props.$block && css`
    width: 100%;
  `}

  &:disabled {
    opacity: .45;
    cursor: default;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

/** A button with no chrome, for tapping a card or a spot on the board. */
export const PlainButton = styled.button`
  display: block;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
  cursor: pointer;
`;

export const Select = styled.select`
  min-height: 42px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid var(--line);
  background: var(--felt-deep);
`;

export const Muted = styled.span`
  color: var(--muted);
`;

/** Two or three ways to look at the same thing (Mat or Table, Book or Text); the chosen one is highlighted. */
export const ViewSwitch = styled.div`
  display: inline-flex;
  padding: 2px;
  border-radius: 9px;
  background: rgba(255, 255, 255, .08);
`;

export const ViewOption = styled.button<{ $on?: boolean }>`
  border: 0;
  border-radius: 7px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: ${props => props.$on ? 'var(--accent)' : 'transparent'};
  color: ${props => props.$on ? 'var(--accent-ink)' : 'var(--muted)'};
`;
